import { render, staticRenderFns } from "./QuestionButton.vue?vue&type=template&id=1bd9edbc&scoped=true&"
import script from "./QuestionButton.vue?vue&type=script&lang=js&"
export * from "./QuestionButton.vue?vue&type=script&lang=js&"
import style0 from "./QuestionButton.vue?vue&type=style&index=0&id=1bd9edbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd9edbc",
  null
  
)

export default component.exports